"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DisabilityCardLevel;
(function (DisabilityCardLevel) {
    DisabilityCardLevel["None"] = "none";
    DisabilityCardLevel["DisabledPerson"] = "disabledPerson";
    DisabilityCardLevel["LegallyBlind"] = "legallyBlind";
    DisabilityCardLevel["ThirdPartyNeeded"] = "thirdPartyNeeded";
})(DisabilityCardLevel || (DisabilityCardLevel = {}));
exports.default = DisabilityCardLevel;
